
import React from 'react';
import { Link } from 'react-router-dom';
import { AnimatedSection } from '@/hooks/useScrollAnimation';
import { useBlogPosts } from '@/hooks/useBlogPosts';

const BlogSection: React.FC = () => {
  const { posts, loading } = useBlogPosts();
  const displayPosts = posts.slice(0, 3);

  if (loading || displayPosts.length === 0) return null;

  return (
    <section id="blog" aria-labelledby="blog-section-title" className="py-12 md:py-16 bg-dark-elevated relative overflow-hidden">
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] decorative-blur decorative-blur-accent opacity-10 pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <AnimatedSection>
          <header className="text-center mb-12 md:mb-16">
            <p className="subtitle-wide text-gold mb-3 block">Conteúdo</p>
            <h2 id="blog-section-title" className="text-3xl md:text-4xl text-light-primary tracking-tight leading-tight">
              Saiba antes de decidir
            </h2>
          </header>
        </AnimatedSection>

        <AnimatedSection delay={150}>
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 list-none p-0 m-0">
            {displayPosts.map((post, index) => (
              <li key={index} className="list-none">
                <article className="group cursor-pointer flex flex-col gap-5">
                  <Link to={`/blog/${post.slug}`} className="contents">
                    <figure className="w-full aspect-video rounded-2xl overflow-hidden bg-dark-surface border border-white/8 relative m-0">
                      {post.image ? (
                        <img src={post.image} alt={post.title} title={post.title} className="img-zoom" loading="lazy" decoding="async" width="640" height="360" />
                      ) : (
                        <div className="w-full h-full flex flex-col items-center justify-center gap-2">
                          <div className="w-10 h-10 rounded-full border border-gold/20 flex items-center justify-center" aria-hidden="true">
                            <div className="w-2 h-2 rounded-full bg-gold/40" />
                          </div>
                          <span className="text-light-muted/40 text-[10px] uppercase tracking-widest">Foto em breve</span>
                        </div>
                      )}
                      <div className="absolute inset-0 bg-gradient-to-t from-dark-base/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" aria-hidden="true" />
                    </figure>
                    <header className="flex flex-col gap-2">
                      <h3 className="text-lg text-light-primary font-medium leading-snug line-clamp-2 group-hover:text-gold transition-colors duration-300">
                        {post.title}
                      </h3>
                      <p className="text-sm text-light-muted leading-relaxed line-clamp-2">{post.excerpt}</p>
                      {post.date && (
                        <time className="text-xs text-light-muted/50 font-medium mt-1">{post.date}</time>
                      )}
                    </header>
                  </Link>
                </article>
              </li>
            ))}
          </ul>
        </AnimatedSection>

        <AnimatedSection delay={200}>
          <div className="mt-12 flex justify-center">
            <Link to="/blog" className="btn-pill btn-gold font-semibold text-sm px-8 py-3">
              Ver todos os artigos
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default BlogSection;
